import { useTranslation } from 'react-i18next';

export const useCommonTranslation = () => {
  return useTranslation('indrive.common');
};
export const useArchiveActionLogTranslation = () => {
  return useTranslation('indrive.archive.actionLog');
};
export const useArchiveModalTranslation = () => {
  return useTranslation('indrive.archive.modal');
};
export const useErrorTranslation = () => {
  return useTranslation('indrive.errors');
};
